import request from "../../utils/request";

export function getDepartmentTree() {
  return request({
    url: "/departments",
    method: "get"
  });
}

export function getDepartmentPersonnelOptions() {
  return request({
    url: "/departments/personnel-options",
    method: "get"
  });
}

export function createDepartment(data) {
  return request({
    url: "/departments",
    method: "post",
    data
  });
}

export function updateDepartment(id, data) {
  return request({
    url: `/departments/${id}`,
    method: "put",
    data
  });
}

export function deleteDepartment(id) {
  return request({
    url: `/departments/${id}`,
    method: "delete"
  });
}
